import React from "react";
import "./style.scss";

const Loader = () => {
  return (
    <div className="end-loader" id="end-loader-1">
      <div className="end-loader-spinner"></div>
    </div>
  );
};

export default Loader;
